import * as React from "react";
import { TweenMax, Back } from "gsap";
import injectSheet from "react-jss";
import classNames from "classnames";

const styleSheet = {
  formItem: {
    // height: "145px",
    position: "relative",
    boxSizing: "border-box",
    paddingRight: "15px",
    paddingLeft: "15px",
    marginBottom: "20px",
    "@media (max-width: 900px)": {
      height: "auto",
      marginBottom: "19px",
      padding: 0
    }
  },
  compressHeight: {
    maxHeight: '50px',
    marginBottom: "2px"
  }  
};

interface Props {
  classes: any;
  theme?: any;
  width: string;
  index: number;
  zIndex?: number;
  compressHeight?: boolean;
}

const FormItem: React.FC<Props> = props => {
  return (
    <div
      className={classNames(
        props.classes.formItem,
        {[props.classes.compressHeight]: props.compressHeight}
        )}
      style={{
        width: props.width || "100%",
        flex: props.width || "100%",
        zIndex: props.index ? 1000 - props.index : 1
      }}
    >
      {props.children}
    </div>
  );
};

export default injectSheet(styleSheet)(FormItem);
